import { CUSTOM_ELEMENTS_SCHEMA, NgModule, getPlatform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule, Platform } from '@ionic/angular';

import { SurveyMapPageRoutingModule } from './survey-map-routing.module';

import { TranslateModule } from '@ngx-translate/core';
import { SurveyMapPage } from './device/survey-map.page';
import { SurveyMapBrowserPage } from './browser/survey-map-browser.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [ComponentsModule, CommonModule, FormsModule, IonicModule, SurveyMapPageRoutingModule, TranslateModule.forChild()],
  declarations: [SurveyMapPage, SurveyMapBrowserPage]
})
export class SurveyMapPageModule {}
